import PcColumnLayout from '../components/PcColumnLayout/index.vue';
import PcFeatureCard from '../components/PcFeatureCard/index.vue';
import PcLayoutContainer from '../components/PcLayoutContainer/index.vue';
import PcLearnMore from '../components/PcLearnMore/index.vue';
import PcLifeStyle from '../components/PcLifeStyle/index.vue';
import PcVideoBanner from '../components/PcVideoBanner/index.vue';
import PcOverviewIntro from '../components/PcOverviewIntro/index.vue';
import PcDisclaimerBlock from '../components/PcDisclaimerBlock/index.vue';
import PcDisclaimerItem from '../components/PcDisclaimerItem/index.vue';
import PcDisclaimerIcon from '../components/PcDisclaimerIcon/index.vue';
import PcCopy from '../components/PcCopy/index.vue';
import PcTable from '../components/PcTable/index.vue';
import PcTableRow from '../components/PcTableRow/index.vue';
import PcTableCell from '../components/PcTableCell/index.vue';

export default {
  PcColumnLayout,
  PcFeatureCard,
  PcLayoutContainer,
  PcLearnMore,
  PcLifeStyle,
  PcVideoBanner,
  PcOverviewIntro,
  PcDisclaimerBlock,
  PcDisclaimerItem,
  PcDisclaimerIcon,
  PcCopy,
  PcTable,
  PcTableRow,
  PcTableCell,
};
